import { z } from 'zod';

export const LoginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter a valid email'),
  password: z.string().min(1, 'Password is required'),
  rememberMe: z.boolean().default(false),
});

export type LoginValues = z.infer<typeof LoginSchema>;

// Mirrors the Cognito password policy (infra/auth.go): 12+ chars with an
// upper, lower, number and symbol. Used by the invite-accept and
// password-reset set-password forms so users see the requirement up front
// instead of getting a confusing Cognito 400.
export const StrongPasswordSchema = z
  .string()
  .min(12, 'Use at least 12 characters')
  .regex(/[a-z]/, 'Include a lowercase letter')
  .regex(/[A-Z]/, 'Include an uppercase letter')
  .regex(/[0-9]/, 'Include a number')
  .regex(/[^A-Za-z0-9]/, 'Include a symbol');

export const SetPasswordSchema = z
  .object({
    newPassword: StrongPasswordSchema,
    confirmNewPassword: z.string().min(1, 'Confirm your new password'),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords do not match',
    path: ['confirmNewPassword'],
  });

export type SetPasswordValues = z.infer<typeof SetPasswordSchema>;
